const RESOURCE_ALIASES = {
  java: 'java-basics',
  'java 基础': 'java-basics',
  spring: 'spring-boot',
  'spring boot': 'spring-boot',
  springboot: 'spring-boot',
  mysql: 'mysql',
  redis: 'redis',
  docker: 'docker',
  github: 'github',
  api: 'api',
  蓝桥杯: 'lanqiao',
  lanqiao: 'lanqiao',
  软考: 'ruankao',
  软件设计师: 'ruankao',
  英语四六级: 'cet',
  四级: 'cet',
  六级: 'cet',
  简历优化: 'resume-polish',
  面试准备: 'interview-prepare',
  项目实战: 'project-practice',
  ai: 'ai-tools',
  'ai 工具': 'ai-tools',
  'ai agent': 'ai-agent',
}

export const LEARNING_RESOURCES = [
  {
    id: 'spring-boot',
    title: 'Spring Boot',
    category: '后端开发',
    intro: 'Java 做网站后端的主流框架，适合做登录、接口、管理系统和业务后台。',
    why: '后端实习和 Java 项目里很常见，学会后能把页面、数据库和业务逻辑串起来。',
    order: ['先懂 API 是什么', '再学 Controller / Service / Mapper 分层', '连接 MySQL 做增删改查', '加入登录、权限和错误处理', '做一个可演示管理系统'],
    videos: ['B站：Spring Boot 入门到项目实战', 'B站：Java Web + Spring Boot 管理系统'],
    docs: [{ label: 'Spring 官方文档', url: 'https://spring.io/projects/spring-boot' }],
    practice: ['若依 RuoYi：学习后台系统结构', 'Apifox / Postman：练接口测试'],
    openSource: ['RuoYi-Vue', 'mall-learning', 'spring-petclinic'],
    courses: ['Java Web 课程设计', 'Spring Boot CRUD 小项目课'],
    articles: ['Spring Boot 分层结构怎么理解', 'Controller、Service、Mapper 分别做什么'],
    interviews: ['Spring Boot 自动配置是什么', '如何设计一个登录接口', 'MySQL 和 Redis 在项目里怎么配合'],
    projects: ['学生信息管理系统', '博客后台接口', '校园二手交易后台'],
    next: '先做 3 个接口：列表查询、新增、删除，再把数据存进 MySQL。',
  },
  {
    id: 'mysql',
    title: 'MySQL',
    category: '数据库',
    intro: '常见关系型数据库，用来保存用户、订单、文章、成绩这类结构化数据。',
    why: '几乎所有管理系统都需要数据库，MySQL 是最适合入门和写项目的选择之一。',
    order: ['理解表、字段、主键', '练 SELECT / INSERT / UPDATE / DELETE', '设计 3 张业务表', '学习表关系和索引', '接入后端项目'],
    videos: ['B站：MySQL 零基础入门', 'B站：SQL 查询练习'],
    docs: [{ label: 'MySQL 官方文档', url: 'https://dev.mysql.com/doc/' }],
    practice: ['SQLBolt', 'LeetCode Database 简单题', '牛客 SQL 入门题'],
    openSource: ['RuoYi 数据库表结构', 'mall-learning 数据库设计'],
    courses: ['数据库原理课程设计', 'SQL 入门训练营'],
    articles: ['主键和外键是什么', '索引为什么能让查询变快'],
    interviews: ['主键和唯一索引区别', '什么是事务', '如何设计用户表'],
    projects: ['图书借阅数据库', '校园二手交易数据库', '课程成绩管理表'],
    next: '今天先设计用户表、商品表、订单表，并写出 5 条查询 SQL。',
  },
  {
    id: 'redis',
    title: 'Redis',
    category: '缓存',
    intro: '让网站访问更快的缓存工具，常用来保存验证码、登录状态或热门数据。',
    why: '后端项目里加一个 Redis 小功能，能让简历项目显得更接近真实业务。',
    order: ['先理解缓存是什么', '学习 key/value 和过期时间', '做验证码缓存', '做热门数据缓存', '写进项目亮点'],
    videos: ['B站：Redis 入门教程', 'B站：Redis 实战验证码缓存'],
    docs: [{ label: 'Redis 官方文档', url: 'https://redis.io/docs/latest/' }],
    practice: ['本地安装 Redis 并练 SET / GET', '用 Spring Boot 接入 Redis'],
    openSource: ['mall-learning Redis 模块', 'RuoYi 登录缓存逻辑'],
    courses: ['Redis 入门实战', 'Java 后端缓存专题'],
    articles: ['缓存是什么', 'Redis 过期时间怎么用'],
    interviews: ['Redis 常见数据类型', '缓存穿透是什么', '验证码为什么适合放 Redis'],
    projects: ['登录验证码缓存', '热门商品缓存', '接口访问次数限制'],
    next: '先做一个“验证码 5 分钟过期”的小功能。',
  },
  {
    id: 'java-basics',
    title: 'Java 基础',
    category: '编程基础',
    intro: 'Java 是后端开发常用语言，适合做管理系统、接口和企业应用。',
    why: '如果目标是 Java 后端，基础语法、集合和面向对象是后面学 Spring Boot 的地基。',
    order: ['变量和条件循环', '类、对象、方法', 'List / Map 集合', '异常和调试', '做一个命令行小项目'],
    videos: ['B站：Java 零基础入门', 'B站：Java 面向对象基础'],
    docs: [{ label: 'Java 官方教程', url: 'https://dev.java/learn/' }],
    practice: ['牛客 Java 入门题', 'LeetCode 简单题', '蓝桥杯 Java 入门题'],
    openSource: ['Java samples', 'spring-petclinic'],
    courses: ['Java 程序设计', '面向对象程序设计'],
    articles: ['类和对象怎么理解', 'List 和 Map 什么时候用'],
    interviews: ['面向对象三大特性', 'ArrayList 和 HashMap 基础', '异常处理怎么写'],
    projects: ['学生信息管理小程序', '命令行记账本'],
    next: '今天先写一个学生信息增删查的小练习。',
  },
  {
    id: 'lanqiao',
    title: '蓝桥杯',
    category: '竞赛',
    intro: '适合计算机、软件、电子类学生的入门到进阶编程竞赛。',
    why: '对低年级学生友好，能训练编程基础，也能作为简历和综测经历。',
    order: ['确认报名组别', '刷基础语法题', '练常见算法模板', '每周复盘错题', '准备模拟赛'],
    videos: ['B站：蓝桥杯 Java / C++ 入门', 'B站：蓝桥杯真题讲解'],
    docs: [{ label: '蓝桥杯官网', url: 'https://dasai.lanqiao.cn/' }],
    practice: ['蓝桥云课', 'AcWing 蓝桥杯专题', '洛谷入门题'],
    openSource: ['GitHub 蓝桥杯题解仓库'],
    courses: ['蓝桥杯省赛训练营'],
    articles: ['蓝桥杯备赛路线', '低年级如何准备算法竞赛'],
    interviews: ['常见排序和搜索', '动态规划入门题', '模拟题如何调试'],
    projects: ['题解笔记仓库', '算法可视化小工具'],
    next: '今天先选语言和组别，完成 3 道入门题。',
  },
  {
    id: 'ruankao',
    title: '软考',
    category: '证书',
    intro: '软件行业常见证书，初级/中级适合计算机相关学生作为基础能力证明。',
    why: '软考能系统补软件工程、数据库、网络和项目管理知识，但不要替代真实项目。',
    order: ['先选初级或中级', '看考试大纲', '刷历年真题', '整理错题', '用项目理解知识点'],
    videos: ['B站：软考软件设计师备考', 'B站：软考数据库与网络基础'],
    docs: [{ label: '中国计算机技术职业资格网', url: 'https://www.ruankao.org.cn/' }],
    practice: ['软考真题库', '希赛 / 牛客软考练习'],
    openSource: ['软考笔记整理仓库'],
    courses: ['软件设计师备考课'],
    articles: ['软考中级怎么选', '软考和项目经历怎么搭配'],
    interviews: ['软件工程生命周期', '数据库范式', '网络基础题'],
    projects: ['把软考知识点应用到管理系统设计说明'],
    next: '今天先下载考试大纲，判断自己适合初级还是中级。',
  },
  {
    id: 'project-practice',
    title: '项目实战',
    category: '作品集',
    intro: '把学过的工具串成一个能演示、能截图、能讲清楚的小作品。',
    why: '项目是连接学习路线、简历、面试和竞赛的核心材料。',
    order: ['选一个小题目', '写最小功能清单', '完成核心流程', '截图和写说明', '改成简历 bullet'],
    videos: ['B站：课程设计项目实战', 'B站：从 0 到 1 做作品集项目'],
    docs: [{ label: 'GitHub Explore', url: 'https://github.com/explore' }],
    practice: ['照着一个开源项目复现最小版', '每天提交一个小功能'],
    openSource: ['RuoYi', 'mall-learning', 'portfolio templates'],
    courses: ['毕设/课程设计实战课'],
    articles: ['简历项目怎么选题', '项目 README 怎么写'],
    interviews: ['项目难点是什么', '你负责哪部分', '如果重做会怎么优化'],
    projects: ['校园二手交易', '学习计划工具', '数据看板'],
    next: '今天只确定一个最小版本：3 个功能、1 张数据表、1 个演示页面。',
  },
  {
    id: 'ai-tools',
    title: 'AI 工具',
    category: 'AI 应用',
    intro: '用 AI 辅助学习、写作、编程、简历和资料整理的工具集合。',
    why: '不需要一开始懂模型原理，先学会把任务说清楚、检查结果、沉淀流程。',
    order: ['学会写清楚目标', '给 AI 提供背景材料', '让 AI 生成清单或草稿', '人工检查和修改', '沉淀成作品或模板'],
    videos: ['B站：AI 工具效率入门', 'B站：Prompt 基础教程'],
    docs: [{ label: 'OpenAI Docs', url: 'https://platform.openai.com/docs' }],
    practice: ['用 AI 改写一段项目经历', '用 AI 生成学习计划并人工修正'],
    openSource: ['awesome-ai-tools', 'ChatGPT prompts'],
    courses: ['AI 工具应用入门课'],
    articles: ['Prompt 怎么写清楚', 'AI 生成内容如何检查'],
    interviews: ['你如何使用 AI 提升效率', 'AI 结果不可靠时怎么处理'],
    projects: ['AI 简历助手', 'AI 学习资料整理工具'],
    next: '今天先把一个真实任务拆成“背景、目标、限制、输出格式”。',
  },
]

export function normalizeResourceId(value = '') {
  const text = String(value).trim()
  if (!text) return ''
  const lower = text.toLowerCase()
  const exact = RESOURCE_ALIASES[text] || RESOURCE_ALIASES[lower]
  if (exact) return exact
  const compact = lower.replace(/\s+/g, '-').replace(/[^\w\u4e00-\u9fa5-]/g, '')
  if (LEARNING_RESOURCES.some((item) => item.id === compact)) return compact
  const fuzzy = LEARNING_RESOURCES.find((item) => (
    lower.includes(item.title.toLowerCase()) || item.title.toLowerCase().includes(lower)
  ))
  return fuzzy?.id || compact
}

export function getLearningResource(value = '') {
  const id = normalizeResourceId(value)
  return LEARNING_RESOURCES.find((item) => item.id === id) || null
}

export function getLearningResourcePath(value = '') {
  return `/student/resources/${encodeURIComponent(normalizeResourceId(value) || 'project-practice')}`
}

export function markResourceLearned(resourceId) {
  if (typeof window === 'undefined') return []
  const id = normalizeResourceId(resourceId)
  const current = getLearnedResources()
  const next = Array.from(new Set([...current, id]))
  window.localStorage.setItem('student_learned_resources', JSON.stringify(next))
  return next
}

export function getLearnedResources() {
  if (typeof window === 'undefined') return []
  try {
    const parsed = JSON.parse(window.localStorage.getItem('student_learned_resources') || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
